import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export const isEmailValid: ValidatorFn = (control: UntypedFormGroup): { [key: string]: any } | null => {
  const reg = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+' +
    '(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@' +
    '((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|' +
    '(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');

  if (control.value != null && control.value.length > 0 && !reg.test(control.value)) {
    return { emailNotValid: true };
  }

  return null;
};
